@if (ecashView) {
<h2 class="text-black mb-4 d-lg-block d-none">
  {{ 'payment.history.page.title' | translate }}
</h2>
}

<div class="card border mt-3 mt-lg-0">
  <div [ngClass]="{ 'card-body-ecash': ecashView, 'card-body-account': accountView }">
    <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-end gap-2">
      <fgbcl-date-range-picker
        [startDate]="transactionStartDate()"
        (startDateChange)="transactionStartDate.set($event)"
        [endDate]="transactionEndDate()"
        (endDateChange)="transactionEndDate.set($event)"
      ></fgbcl-date-range-picker>

      <div class="d-flex gap-2">
        <button type="button" class="search-button rounded fw-bold mb-2 d-block text-white bg-primary" (click)="search()">
          {{ 'transaction.history.search' | translate : { fgbdefault: 'Search' } }}
        </button>
      </div>
    </div>
  </div>
</div>

@if (selectedValues()) {
<fgb-transaction-list
  [startDate]="selectedValues()!.start"
  [endDate]="selectedValues()!.end"
  [memberId]="memberId"
  [transactionType]="selectedValues()!.type"
></fgb-transaction-list>
}
